import styled from "styled-components"
import { ExtraSmall} from "../Responsive"
//Styled Components
const Container=styled.div`
background-color: #E8E9ED;
border-radius: 6px;
display:flex;
flex-direction: column;
gap: 20px;
min-height:40vh;
padding: 15px;
margin: 0px auto;
width: 90vw;
`
const Title=styled.h3`
font-weight: 500;
`
const Image=styled.img`
object-fit:cover;
border-radius: 6px;
height: 400px;
width: 100%;
${ExtraSmall({height:'250px'})}
`
const Content=styled.div`
// background-color: pink;
min-height: 200px;
width: 100%;
`
const Para=styled.p`
font-size:13px;
line-height:1.5;
// font-weight: 200;
`
const ContentBox=(props)=>{
    return(
       <Container>
        {
          props.data.map((item)=>{
            return(
                <>
                 <Title>{item.title}</Title>
                 {
                    item.img ? <Image src={item.img} alt='image'></Image> :null
                 }
                 
                 <Content>
                   <Para>
                     {item.content}
                   </Para>
                </Content>
                </>
            )
          })
        }
       
       </Container>
    )
}
export default ContentBox